export const ErrorCodes = {
  invalid_request: 'D-001',
  unauthorized_client: 'D-002',
  access_denied: 'D-003',
  invalid_auth: 'D-004',
  timestamp_refused: 'D-005',
  unsupported_response_type: 'D-006',
  invalid_scope: 'D-007',
  server_error: 'D-008',
  request_not_supported: 'D-016',
  request_uri_not_supported: 'D-017',
  registration_not_supported: 'D-018',
};

export const ErrorMessages = {
    'D-001': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-002': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-003': 'お客様のdアカウント情報をマカフィーにご提供頂けないためログインできません。<br/>改めて以下の「ログイン」ボタンをクリックし、dアカウント認証後、お客様のdアカウント情報をマカフィーにご提供頂けますようお願いします。',
    'D-004': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-005': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-006': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-007': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-008': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-016': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-017': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-018': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'D-099': '予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',

    'M-000':'予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。',
    'M-001':'以下のサービスのいずれもご契約がないため、ログインできません。<br/>ご契約後に再度ログインしてください。<br/>・ネットワークセキュリティ<br/>・あんしんセキュリティ トータルプラン<br/>・あんしんセキュリティ トータルプラン 詐欺対策プラス<br/>',
    'M-003':'予期せぬエラーが発生しました。<br/>以下の「ログイン」ボタンをクリックして改めてお試し下さい。<br/>エラーが継続する場合はマカフィーサポートセンターへお問い合わせください。'
    };
